module.exports = __webpack_public_path__ + "static/img/thumbnail.be08f2fc.webp";